import React, { useState, useEffect } from 'react';
import {
    AiOutlineFolder,
    AiOutlineFolderOpen,
    AiOutlineCheckSquare,
    AiOutlineUser,
    AiOutlineTeam
} from 'react-icons/ai';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTelegram, } from '@fortawesome/free-brands-svg-icons';
import './css/Treeview.css';
function TreeviewRow({ item, level, loadChildren }) {
    const [isExpanded, setIsExpanded] = useState(false);
    const [children, setChildren] = useState([]);
    const [loadingChildren, setLoadingChildren] = useState(false);

    const hasChildren = item.children !== undefined; // Тепер children може бути undefined до завантаження

    const toggleExpand = async () => {
        if (hasChildren && !isExpanded && !children.length) {
            setLoadingChildren(true);
            const loadedChildren = await loadChildren(item.id, level);
            setLoadingChildren(false);
            if (loadedChildren) {
                setChildren(loadedChildren);
                setIsExpanded(true);
            }
        } else if (hasChildren) {
            setIsExpanded(!isExpanded);
        }
    };

    const indentation = level * 10;
    let otsp = []
    for (let index = 0; index < level; index++) {
        otsp.push(<span className="otsp" style={{ marginRight: "10px" }}></span>)
    }

    return (
        <>
            <tr className="treeview-row">
                <td>
                    {otsp}
                    {hasChildren ? (
                        <button className="expand-button" onClick={toggleExpand} disabled={isExpanded && !children.length && loadingChildren}>
                            <span style={{ fontSize: "1.3em" }}>
                                {isExpanded ? <AiOutlineFolderOpen /> : <AiOutlineTeam />}
                            </span>
                            <span style={{ marginLeft: "5px", color: item.data == 1 ? "#8bd159" : "#BDBDBD" }}>{item.name}</span>
                            {item.username ?
                                <a className="menu-button"
                                    href={"https://t.me/" + item.username}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{ height: "100%", border: "none", marginLeft: "5px" }}
                                >
                                    <FontAwesomeIcon icon={faTelegram} />
                                </a>
                                : null}
                            {loadingChildren && ' (Load...) '}
                        </button>
                    ) : (
                        <button className="expand-button">
                            <AiOutlineUser className="file-icon" />
                            <span style={{ marginLeft: "5px", color: item.data == 1 ? "#8bd159" : "#BDBDBD" }}>{item.name}</span>
                            {item.username ?
                                <a className="menu-button"
                                    href={"https://t.me/" + item.username}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{ height: "100%", border: "none", marginLeft: "5px" }}
                                >
                                    <FontAwesomeIcon icon={faTelegram} />
                                </a>
                                : null}
                        </button>
                    )}
                </td>
            </tr>
            {isExpanded && children.map((child) => (
                <TreeviewRow key={child.id} item={child} loadChildren={loadChildren} level={level + 1} />
            ))}
        </>
    );
}

export default TreeviewRow;